import {HTTP_STATUS} from '../constants/Type'
import {API_URL, PTN_DC, PTN_KG, PTN_DAROS_OUTPUT, STORAGE_KEY, DC_STORAGE_KEY, KG_STORAGE_KEY} from '../constants/App'
import router from '../router'
import * as Util from './App'

/** APIユーティリティ */

/**
 * 共通エラーハンドリング
 * @param  {Object} error エラー
 * @param  {Object} errorMessage エラーメッセージ用フィールド
 * @param  {Object} validationErrorMessages バリデーションエラーメッセージ用フィールド
 * @return
 */
export const handleError = (error, errorMessage, validationErrorMessages) => {
  let url = location.href
  if (Util.isLocal() || Util.isDev()) {
    console.log('▼▼▼▼ DEBUG:ERROR ▼▼▼▼')
    console.log(error)
    if (error) console.log(error.response)
    console.log('▲▲▲▲ DEBUG:ERROR ▲▲▲▲')
  }

  if (!error || !error.response) {
    // if (Util.isDev()) {
    if (!PTN_DC.test(url)) {
      Util.showModal({
        title: 'サーバーエラー',
        messages: [error],
        messageType: 'error',
        textAlign: 'left'
      })
    }
    // } else {
    // エラー画面遷移
    // router.push('/error')
    // }
    return {}
  }

  switch (error.response.status) {
    // システムエラー
    case HTTP_STATUS.INTERNAL_SERVER_ERROR:
      // if (Util.isDev()) {
      if (PTN_DC.test(url)) {
        router.push('/mmstyle/error')
      } else {
        Util.showModal({
          title: 'サーバーエラー',
          messages: [error.response.data.errorMessage],
          messageType: 'error',
          textAlign: 'left'
        })
      }
      // } else {
      // エラー画面遷移
      // router.push('/error')
      // }
      break
    // 認証エラー
    case HTTP_STATUS.UNAUTHORIZED:
      let errorMessages = ['セッションの有効期限が切れています', 'お手数ですが、再度ログインを行なってください。']
      if (error.response.data.errorMessage !== undefined) {
        errorMessages = [error.response.data.errorMessage]
      }
      if (PTN_KG.test(url)) {
        router.push('/kagull/login')
      } else if (PTN_DC.test(url)) {
        router.push({
          name: 'DcError',
          params: { errorMessages: errorMessages }
        })
      } else {
        // 出力物管理画面へのリクエストの場合はログイン画面→出力物管理画面へと遷移させる
        if (PTN_DAROS_OUTPUT.test(url)) {
          Util.setLocalStorage(STORAGE_KEY.TRANSITION_URL_NAME, 'Output')
          router.push({
            name: 'Login'
          })
        } else {
          router.push({
            name: 'Error',
            params: { errorMessages: errorMessages }
          })
        }
      }
      break
    // パーミッションエラー
    case HTTP_STATUS.FORBIDDEN:
      // 画面初期表示の場合はログインしているサービスのトップ画面を表示
      let requestUrl = error.config.url
      let paramsPageUrl = error.config.params.pageUrl
      if (requestUrl != null && requestUrl.match(API_URL.INIT) && paramsPageUrl != null) {
        let darosUserInfo = localStorage.getItem(STORAGE_KEY.USER_INFO)
        let dcUserInfo = localStorage.getItem(DC_STORAGE_KEY.USER_INFO)
        let kgUserInfo = localStorage.getItem(KG_STORAGE_KEY.USER_INFO)
        if (darosUserInfo != null && paramsPageUrl !== '/') {
          router.push('/')
          break
        } else if (dcUserInfo != null && paramsPageUrl !== '/mmstyle/top') {
          router.push('/mmstyle/top')
          break
        } else if (kgUserInfo != null && paramsPageUrl !== '/kagull/top') {
          router.push('/kagull/top')
          break
        }
      }
      // APIの場合はモーダル表示
      Util.showModal({
        title: 'エラー',
        messages: ['ご利用中のユーザーでは許可されない操作です。'],
        messageType: 'error'
      })
      break
    // バリデーションエラー
    case HTTP_STATUS.BAD_REQUEST:
      if (PTN_DC.test(url)) {
        router.push('/mmstyle/error')
      } else {
        // TODO カンマ区切りやめる。メッセージは設定するのではなく、戻り値で返すようにする。
        // フィールドエラーメッセージの設定
        if (validationErrorMessages !== undefined) {
          let errors = error.response.data.validationErrors
          for (let propName in errors) {
            validationErrorMessages[propName] = errors[propName].join(', ')
          }
        }
      }
      break
    default:
      // if (Util.isDev()) {
      if (!PTN_DC.test(url)) {
        Util.showModal({
          title: 'サーバーエラー',
          messages: [error],
          messageType: 'error',
          textAlign: 'left'
        })
      }
      // } else {
      // エラー画面遷移
      // router.push('/error')
      // }
      break
  }
  if (errorMessage !== undefined) {
    errorMessage.text = error.response.data.errorMessage
  }
  return {
    errorMessage: error.response.data.errorMessage,
    validationErrorMessages: error.response.data.validationErrors
  }
}



// WEBPACK FOOTER //
// ./src/main/js/utils/Api.js